export default __webpack_public_path__ + "static/media/close.104d3ec3.svg";